import _orderBy from 'lodash/orderBy';


export const state = {
    sortCurrentChildFile: {
        loading: false,
        data: [],
    },
}


export const getters = {
}


export const mutations = {
    // SORTING FILE
    sortByFile: (state, data) => {
        let selectedItems = data.items;
        let order = data.order;
        let key = data.key;

        state.sortCurrentChildFile.data = selectedItems;

        state.sortCurrentChildFile.data = _orderBy(selectedItems, key, order.toLowerCase());
    }
}


export const actions = {
}